import { styled } from '$utils/theme'
import { Text } from '../Text'
import { Division } from '../Division'
import { css } from 'styled-components'
import { rem } from 'polished'

interface Props {
  enable?: boolean
  position?: boolean
}

export const StyledNumber = styled(Text).attrs({})<Props>`
  width: 32px;
  height: 32px;
  font-weight: 900;
  padding-top: ${rem(3)};
  padding-left: ${rem(1)};
  border: 2px solid ${p => p.theme.colors.greyShadow};
  border-radius: 25px;
  ${p =>
    p.enable &&
    css`
      border: 2px solid ${p.theme.colors.darkGrey};
    `};
`

export const StyleDivision = styled(Division)`
  border: solid 2px;
`

export const StyledBlock = styled.div.attrs({})<Props>`
  padding-top: ${p => rem(p.theme.sizes.base)};
  text-align: center;
  z-index: 1;
  ${p =>
    p.enable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `} ${p =>
    p.position &&
    `
    background-color: ${p.theme.colors.xlightBlue};
  `};
`



// WEBPACK FOOTER //
// ./src/views/components/Step/Step.style.ts